import { useTranslation } from "react-i18next";
import Section from "./Section";
import { LocaleLink as Link } from "./LocaleLink";
import { trackEvent } from "@/lib/analytics";

// Iconos 3D del kit Playium en /public/icons/. Cada par dolor → solución
// tiene su variante coral (pain) y mint (solution). El orden (cobro →
// cronómetro → evento) debe coincidir con el de `items` en el i18n.
const PAIRS: Array<{ pain: string; solution: string }> = [
  { pain: "/icons/ICONO_COBRAR.webp", solution: "/icons/ICONO_CHECK.webp" },
  { pain: "/icons/ICONO_CRONOMETRO.webp", solution: "/icons/ICONO_CRONOMETRO_2.webp" },
  { pain: "/icons/ICONO_EVENTO.webp", solution: "/icons/ICONO_RESERVA_CONFIRMACION.webp" },
];

interface PairText {
  pain: { text: string };
  solution: { text: string; chip?: string };
}

export default function PainsAndSolutions() {
  const { t } = useTranslation();
  const items =
    (t("painsAndSolutions.items", { returnObjects: true }) as unknown as PairText[]) || [];

  return (
    <Section id="pains-solutions" className="playium-pains">
      {/* Decoraciones 3D — fuera del inner: viven en el gutter entre el
          borde del container (1440) y el viewport. Las anclamos con
          calc(50% + 720px) para que su borde interno toque exactamente el
          borde del container del hero. */}
      <img loading="lazy"
        src="/icons/GEAR_CUT_1.webp"
        alt=""
        aria-hidden="true"
        className="playium-pains__deco playium-pains__deco--gear"
      />
      <img loading="lazy"
        src="/icons/ARCH_SYSTEM_1.webp"
        alt=""
        aria-hidden="true"
        className="playium-pains__deco playium-pains__deco--arch"
      />
      <img loading="lazy"
        src="/icons/ICONO_PILOTES.webp"
        alt=""
        aria-hidden="true"
        className="playium-pains__deco playium-pains__deco--balls"
      />

      <div className="playium-pains__inner">
        <div className="playium-pains__header">
          <h2 className="playium-pains__title playium-heading">
            {t("painsAndSolutions.title")}
          </h2>
          <p className="playium-pains__subtitle">
            {t("painsAndSolutions.subtitle")}
          </p>
        </div>

        <div className="playium-pains__cols" aria-hidden="true">
          <p className="playium-pains__col-head playium-pains__col-head--pain">
            <img loading="lazy" src="/icons/ICONO_TRISTE.webp" alt="" />
            {t("painsAndSolutions.columnPain")}
          </p>
          <span />
          <p className="playium-pains__col-head playium-pains__col-head--solution">
            <img loading="lazy" src="/icons/ICONO_FELIZ.webp" alt="" />
            {t("painsAndSolutions.columnSolution")}
          </p>
        </div>

        <div className="playium-pains__rows">
          {PAIRS.map((pair, i) => {
            const item = items[i];
            if (!item) return null;
            return (
              <div key={i} className="playium-pains__row">
                <div className="playium-pains__card playium-pains__card--pain">
                  <img loading="lazy"
                    src={pair.pain}
                    alt=""
                    aria-hidden="true"
                    className="playium-pains__card-icon"
                  />
                  <p className="playium-pains__card-text">{item.pain.text}</p>
                </div>

                <div className="playium-pains__connector" aria-hidden="true">
                  <img loading="lazy" src="/icons/ICONO_FLECHA.webp" alt="" />
                </div>

                <div className="playium-pains__card playium-pains__card--solution">
                  <img loading="lazy"
                    src={pair.solution}
                    alt=""
                    aria-hidden="true"
                    className="playium-pains__card-icon"
                  />
                  <p className="playium-pains__card-text">{item.solution.text}</p>
                  {item.solution.chip && (
                    <span className="playium-pains__chip">{item.solution.chip}</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div className="playium-pains__cta">
          <Link
            to="/pricing"
            className="playium-hero__cta-primary"
            onClick={() => trackEvent("cta_pricing_clicked", { location: "hub_pains" })}
          >
            {t("painsAndSolutions.cta")}
          </Link>
          <p className="playium-pains__cta-note">{t("painsAndSolutions.ctaNote")}</p>
        </div>
      </div>
    </Section>
  );
}
